import { useSelector } from 'react-redux';
import { getAddKanbanItemsToCart } from 'b2b-apps/core/kanban';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { AddItemsToCartType } from 'b2b-common/core/cart/api/CartTypes';

export type UseAddItemsToCartDataReturnType = RemoteRecord<AddItemsToCartType>;

export const useAddKanbanItemsToCartData = (): UseAddItemsToCartDataReturnType => useSelector(getAddKanbanItemsToCart);
